/*
  Leina Label: hover quick add size selection.
  Picking a size writes the variant ID into the card's product form and enables the button.
  Adding to cart and opening the cart drawer is handled by the theme's assets/product-form.js.
  Uses one document-level listener, so it keeps working after filtering, sorting and theme editor reloads.
*/
(function () {
  if (window.leinaHoverQuickAdd) return;
  window.leinaHoverQuickAdd = true;

  function selectSize(radio) {
    var root = radio.closest('[data-leina-qa]');
    if (!root) return;

    var idInput = root.querySelector('input[name="id"]');
    var button = root.querySelector('.leina-qa__submit');
    var label = root.querySelector('.leina-qa__label');
    var error = root.querySelector('.leina-qa__error');
    var productForm = root.querySelector('product-form');

    if (idInput) idInput.value = radio.value;

    if (button) {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      if (label && button.dataset.addLabel) label.textContent = button.dataset.addLabel;
    }

    if (error) error.setAttribute('hidden', '');
    if (productForm) productForm.error = false;
  }

  function syncPanel(root) {
    if (!root.querySelector('.leina-qa__radio')) return;

    var checked = root.querySelector('.leina-qa__radio:checked');
    if (checked) {
      selectSize(checked);
      return;
    }

    var idInput = root.querySelector('input[name="id"]');
    var button = root.querySelector('.leina-qa__submit');
    var label = root.querySelector('.leina-qa__label');

    if (idInput) idInput.value = '';
    if (button) {
      button.setAttribute('disabled', '');
      if (label && button.dataset.selectLabel) label.textContent = button.dataset.selectLabel;
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (target && target.classList && target.classList.contains('leina-qa__radio')) {
      selectSize(target);
    }
  });

  // Clicks inside the panel belong to the panel only. Stopping propagation keeps any card-level
  // click script from redirecting to the product page. Native behaviour still runs: a size label
  // still selects its size (firing "change"), and the button still submits its form ("submit").
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('[data-leina-qa]')) {
        event.stopPropagation();
      }
    },
    true
  );

  // Keeps the button state correct when the browser restores a page from back/forward cache.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-leina-qa]').forEach(syncPanel);
  });
})();
